import React, { Component } from "react";
import PropTypes from "prop-types";
import { Layer, Box, Heading, TextInput, Button, Text } from "grommet";
import { Close, Checkmark } from "grommet-icons";
import { callApiGetJson } from "./GlobalSettings"; // Path to your GlobalSettings file

class RedeemPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      error: "",
      loading: false,
    };
  }

  // Restricts text input structure on change
  handleInputChange = (event) => {
    const value = event.target.value;

    // RegEx forces alphanumeric entries only
    const regex = /^[a-zA-Z0-9]*$/;

    // Ensures real-time capping at exactly 5 characters
    if (regex.test(value) && value.length <= 5) {
      this.setState({ inputValue: value, error: "" });
    }
  };

  // Triggers API pipeline execution
  handleSubmit = () => {
    const { inputValue } = this.state;
    const { userToken, onApiSuccess } = this.props;

    // Rigid check to enforce exactly 5 characters
    if (inputValue.length !== 5) {
      this.setState({
        error: "Value must be exactly 5 alphanumeric characters.",
      });
      return;
    }

    this.setState({ loading: true, error: "" });

    // Constructed target URL path string mapping to your backend controller action
    const apiEndpoint = `/Events/redeem_voucher?voucher_code=${inputValue}`;

    // Resolves endpoint appending automatically via APIServerURL string match inside GlobalSettings
    callApiGetJson(apiEndpoint, userToken)
      .then((data) => {
        this.setState({ loading: false });
        if (data !== "") {
          onApiSuccess(data); // Returns JSON payload to parent component context
          this.props.onClose();
        } else {
          this.setState({
            error:
              "Voucher can't be redeemed , Looks like for a given Demo voucher access is already existing for you.",
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: err?.message || "API request rejected or connection failed.",
        });
      });
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { inputValue, error, loading } = this.state;

    // Guard statement handling structural component unmounting or hidden visibility logic
    if (!isOpen) return null;

    return (
      <Layer position="center" onClickOutside={onClose} onEsc={onClose}>
        <Box
          pad="medium"
          width="medium"
          background="background-front"
          round="small"
          elevation="xlarge"
        >
          {/* Header section */}
          <Heading level={3} margin={{ top: "none", bottom: "medium" }}>
            Redeem Your Voucher
          </Heading>
          <Text
            //color="status-critical"
            size="medium"
            margin={{ bottom: "small" }}
          >
            Enter Voucher code received via email.
          </Text>
          {/* Core Grommet Field Component */}
          <Box margin={{ bottom: "medium" }}>
            <TextInput
              placeholder="Enter 5-digit alpha/numeric code"
              value={inputValue}
              onChange={this.handleInputChange}
              disabled={loading}
              focusIndicator={true}
            />
            {error && (
              <Text
                color="status-critical"
                size="small"
                margin={{ top: "small" }}
              >
                {error}
              </Text>
            )}
          </Box>

          {/* Action Row Layout container */}
          <Box direction="row" justify="end" gap="small">
            <Button
              label="Cancel"
              icon={<Close size="small" />}
              onClick={onClose}
              disabled={loading}
              primary
            />
            <Button
              label={loading ? "Submitting..." : "Submit"}
              icon={<Checkmark size="small" />}
              onClick={this.handleSubmit}
              disabled={loading}
              primary
            />
          </Box>
        </Box>
      </Layer>
    );
  }
}

// RedeemPopup.propTypes = {
//   isOpen: PropTypes.bool.isRequired,
//   onClose: PropTypes.func.isRequired,
//   onApiSuccess: PropTypes.func.isRequired,
//   userToken: PropTypes.string, // Optional configuration property depending on authorization requirements
// };

export default RedeemPopup;
